/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostwizercompanydisablePostWizerCompanyDisableResult
 */
export interface JumboPostwizercompanydisablePostWizerCompanyDisableResult {
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanydisablePostWizerCompanyDisableResult
     */
    message?: string;
}

/**
 * Check if a given object implements the JumboPostwizercompanydisablePostWizerCompanyDisableResult interface.
 */
export function instanceOfJumboPostwizercompanydisablePostWizerCompanyDisableResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboPostwizercompanydisablePostWizerCompanyDisableResultFromJSON(json: any): JumboPostwizercompanydisablePostWizerCompanyDisableResult {
    return JumboPostwizercompanydisablePostWizerCompanyDisableResultFromJSONTyped(json, false);
}

export function JumboPostwizercompanydisablePostWizerCompanyDisableResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostwizercompanydisablePostWizerCompanyDisableResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function JumboPostwizercompanydisablePostWizerCompanyDisableResultToJSON(value?: JumboPostwizercompanydisablePostWizerCompanyDisableResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

